import {postMethod, putMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/prepareAccommodationBook', request)
}

async function put(basketKey, request) {
    return await putMethod(`/api/prepareAccommodationBook/${basketKey}`, request)
}

export {post, put}
